module.exports = __webpack_public_path__ + "static/media/BCP.eddd5c0f.png";